import ClearIcon from "@mui/icons-material/Clear";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";
import { DEFAULT_FONTSIZE } from "../utils/utils";
import ErrorHelper from "./ErrorWrapper";
import Flex, { FlexProps } from "./Flex";
import { inputLabel } from "./MaskInput";
import { useFieldLock } from "./ReadOnlyFields";

type InputProps = {
  label?: string;
  flexprops?: FlexProps;
  error?: string | boolean;
  required?: boolean;
  marginBottom?: string;
  /** Show a clear (×) icon that wipes the field in one click when it has a value. */
  clearable?: boolean;
  textFieldProps?: TextFieldProps;
};

const Input = ({
  label,
  flexprops,
  error,
  required,
  clearable = true,
  textFieldProps,
}: InputProps) => {
  const lock = useFieldLock(textFieldProps?.disabled);
  const readOnly = lock.readOnly || !!textFieldProps?.InputProps?.readOnly;

  const hasValue =
    textFieldProps?.value !== undefined &&
    textFieldProps?.value !== null &&
    textFieldProps?.value !== "";

  const showClear =
    clearable &&
    hasValue &&
    !lock.disabled &&
    !textFieldProps?.select &&
    !readOnly;

  const handleClear = () => {
    const name = textFieldProps?.name ?? "";
    // Synthesize a change event so Formik's handleChange (target.name/value)
    // and onChange handlers reading currentTarget keep working.
    const event = {
      target: { name, value: "" },
      currentTarget: { name, value: "" },
    } as React.ChangeEvent<HTMLInputElement>;
    textFieldProps?.onChange?.(event);
  };

  const clearAdornment = showClear ? (
    <InputAdornment position="end">
      <IconButton
        aria-label="Clear input"
        size="small"
        edge="end"
        onClick={handleClear}
        sx={{ padding: "2px" }}
      >
        <ClearIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </InputAdornment>
  ) : null;

  return (
    <Flex
      {...flexprops}
      flexDirection={flexprops?.flexDirection ?? "column"}
      width={textFieldProps?.fullWidth ? "100%" : undefined}
    >
      {/* {props.label && (
        <Typography mb={props.marginBottom ?? "10px"} sx={DEFAULT_FONTSIZE}>
          {props.label}
          {props.required && (
            <Typography
              fontSize={"13px"}
              component={"span"}
              color={"error"}
            >{` *`}</Typography>
          )}
        </Typography>
      )} */}
      <Flex flexDirection={"column"}>
        <ErrorHelper error={error}>
          <TextField
            label={inputLabel(label, required)}
            sx={{ "& .MuiInputBase-input": { ...DEFAULT_FONTSIZE } }}
            fullWidth
            size="small"
            error={!!error}
            InputLabelProps={{ shrink: true }}
            {...textFieldProps}
            disabled={lock.disabled}
            InputProps={{
              ...textFieldProps?.InputProps,
              readOnly,
              endAdornment:
                textFieldProps?.InputProps?.endAdornment ?? clearAdornment,
            }}
          />
        </ErrorHelper>
        {/* {!!props.error && (
          <Text
            fontSize={INPUT_FIELD_TEXT_SIZE}
            variant="caption"
            color="error"
          >
            {props.error}
          </Text>
        )} */}
      </Flex>
    </Flex>
  );
};

export default Input;
